import API from "core/api/axios/base";
import ChangeEmailErrorHandler from "core/api/handler/ChangeEmailErrorHandler";


export function getEmail(token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      "x-accesstoken": token,
    },
    withCredentials: true,
  };

    config.headers["x-credentials-key"] =
      process.env.REACT_APP_X_CREDENTIALS_KEY;
  
  return API.get(`${process.env.REACT_APP_CHANGE_EMAIL}`, config)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = ChangeEmailErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}

export function SendToken(data, token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      "x-accesstoken": token,
    },
    withCredentials: true,
  };

    config.headers["x-credentials-key"] =
      process.env.REACT_APP_X_CREDENTIALS_KEY;
  
  return API.post(`${process.env.REACT_APP_CHANGE_EMAIL}`, data, config)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = ChangeEmailErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}

export function changeEmail(data, token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      "x-accesstoken": token,
    },
    withCredentials: true,
  };

    config.headers["x-credentials-key"] =
      process.env.REACT_APP_X_CREDENTIALS_KEY;

  return API.put(`${process.env.REACT_APP_CHANGE_EMAIL}`, data, config)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = ChangeEmailErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}
